/*
  Related articles on the article page. With no search carried over from the
  blog page, the default list rendered by Liquid is left alone.

  With a search term, articles matching it go first, then the default related
  articles fill the remaining places, up to six in total. The article being
  read is never listed, and nothing appears twice.

  Needs blog-common.js loaded first.
*/
(function () {
  var MAX = 6;

  var grid = document.querySelector('[data-related-grid]');
  var NeoBlog = window.NeoBlog;
  if (!grid || !NeoBlog) return;

  var term = NeoBlog.readTerm();
  if (!term) return;

  var current = NeoBlog.pathOf(grid.dataset.currentUrl);

  NeoBlog.searchArticles(grid.dataset.predictiveUrl, term, grid.dataset.blogUrl)
    .then(function (found) {
      var seen = {};
      seen[current] = true;
      var nodes = [];

      found.forEach(function (article) {
        var path = NeoBlog.pathOf(article.url);
        if (seen[path]) return;
        seen[path] = true;
        nodes.push(NeoBlog.cardNode(article));
      });

      // Nothing related to the search: the default list is already right.
      if (!nodes.length) return;

      var defaults = grid.querySelectorAll('.blog-article');
      for (var i = 0; i < defaults.length; i++) {
        var link = defaults[i].querySelector('a[href]');
        var path = link ? NeoBlog.pathOf(link.getAttribute('href')) : '';
        if (!path || seen[path]) continue;
        seen[path] = true;
        nodes.push(defaults[i]);
      }

      grid.replaceChildren.apply(grid, nodes.slice(0, MAX));
    })
    .catch(function () {
      // A failed search leaves the default related articles in place.
    });
})();
